import React, { useContext } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
import { AiFillEdit } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import AuthContext from 'context/AuthContext'
import { isEmpty, startCase } from 'lodash'
import helper from '../../utils/helpers'
import OImage from 'components/reusable/OImage'

const AmenitiesTable = ({
  amenities,
  handelEdit,
  handleUserView,
  allAmenities,
  page,
  sort,
  setSort,
  paginationObj,
  manager
}) => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const notification = useToastContext()

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.changeStatusAmenities}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        allAmenities()
      }
      // }
    } catch (error) {
      console.error('error in get all sub admin list==>>>>', error.message)
    }
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative 
 border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                #
              </th>

              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sortKey === 'name' && sort.sortType === 'asc') {
                    setSort({
                      sortKey: 'name',
                      sortType: 'desc'
                    })
                  } else {
                    setSort({
                      sortKey: 'name',
                      sortType: 'asc'
                    })
                  }
                }}
              >
                <div className='flex'>
                  <span>{t('O_NAME')} </span>
                  <span>
                    {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sortKey === 'name' && sort.sortType === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sortKey === 'nameAr' && sort.sortType === 'asc') {
                    setSort({
                      sortKey: 'nameAr',
                      sortType: 'desc'
                    })
                  } else {
                    setSort({
                      sortKey: 'nameAr',
                      sortType: 'asc'
                    })
                  }
                }}
              >
                <div className='flex'>
                  <span>{t('O_NAME') + t('O_ARABIC')} </span>
                  <span>
                    {sort.sortKey === 'nameAr' && sort.sortType === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sortKey === 'nameAr' && sort.sortType === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6 cursor-pointer text-center'>
                <span>{t('O_ICON')} </span>
              </th>
              {(manager?.add || user?.role === 'admin') && (
                <>
                  <th scope='col' className='py-3 px-6 text-center'>
                    {t('O_STATUS')}
                  </th>
                  <th scope='col' className='py-3 px-6 text-center'>
                    {t('O_ACTION')}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {amenities &&
              amenities?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>
                    {item?.name}
                  </td>
                  <td className='py-2 px-2 border-r'>{item?.nameAr}</td>
                  <td className='py-2 px-2 border-r text-center'>
                    {item?.icon ? (
                      <OImage
                        src={item?.icon}
                        className='w-12 h-12 m-auto'
                        style={{ borderRadius: '50%' }}
                      />
                    ) : (
                      'N/A'
                    )}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-2 px-2 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `Are you sure want to ${
                                e.target.checked ? 'active' : 'inactive'
                              } ${item.name}?`,
                              item,
                              handelStatusChange
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label>
                    </td>
                  )}
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-4 px-6 border-l'>
                      <div className=''>
                        <ul className='flex justify-center'>
                          <li
                            onClick={() => handelEdit(item)}
                            className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                          >
                            <button title={t('O_EDIT')}>
                              <AiFillEdit className='cursor-pointer w-5 h-5 text-slate-600' />
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            {isEmpty(amenities) && (
              <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-4 px-6' colSpan={12}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AmenitiesTable
